import React, { useContext } from 'react';
import { Dropdown } from 'react-bootstrap';
import AppContext from 'context/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faFilter,
  faChevronDown,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import {
  TicketsDateFilter,
  AgentFilterSelect
} from '../../TicketsView/componentes';

const ReportFilterBar = ({
  statusFilter,
  onStatusChange,
  counts,
  dateFilter,
  onDateChange,
  selectedAgentId,
  onAgentChange,
  agents,
  idUsuario,
  nombreCompleto,
  isLoadingAgents,
  searchTerm,
  onSearchChange
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);

  const statusOptions = [
    { id: 'todos', label: 'Todos los estados', shortLabel: 'Todos', count: counts.todos, dotColor: isDark ? '#94a3b8' : '#64748b' },
    { id: '1', label: 'Pendientes', shortLabel: 'Pendientes', count: counts.pendientes, dotColor: '#f59e0b' },
    { id: '3', label: 'En Progreso', shortLabel: 'En Progreso', count: counts.enProgreso, dotColor: '#3b82f6' },
    { id: '2', label: 'Resueltos', shortLabel: 'Resueltos', count: counts.cerrados, dotColor: '#10b981' },
    { id: 'combinados', label: 'Combinados', shortLabel: 'Combinados', count: counts.combinados, dotColor: '#8b5cf6' }
  ];

  const currentStatusOption = statusOptions.find(opt => opt.id === statusFilter) || statusOptions[0];

  return (
    <div
      className="rounded-3 p-3 mb-3 border"
      style={{
        backgroundColor: isDark ? '#121e2d' : '#ffffff',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      <style>{`
        @media (max-width: 991.98px) {
          .report-filter-date-wrapper .se-tickets-date-filter,
          .report-filter-date-wrapper .dropdown,
          .report-filter-date-wrapper .dropdown-toggle {
            width: 100% !important;
            min-height: 38px !important;
            height: 38px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
          }
          .report-filter-status-toggle {
            min-height: 38px !important;
            height: 38px !important;
          }
          .report-filter-agent-wrapper .se-agent-filter-container {
            width: 100% !important;
            display: flex !important;
            align-items: center !important;
          }
          .report-filter-agent-wrapper .se-agent-filter-select {
            width: 100% !important;
            min-width: 0 !important;
            max-width: 100% !important;
            flex: 1 1 auto !important;
            height: 38px !important;
          }
        }
      `}</style>
      <div className="row g-2 align-items-center">
        {/* Menú Desplegable de Filtro por Estado: 50% en móvil, auto en desktop */}
        <div className="col-6 col-lg-auto">
          <Dropdown className="w-100">
            <Dropdown.Toggle
              as="button"
              type="button"
              className="btn btn-sm d-flex align-items-center justify-content-between border shadow-none px-2 px-sm-3 py-2 rounded-2 transition-base dropdown-caret-none w-100 report-filter-status-toggle"
              style={{
                backgroundColor: isDark ? '#121e2d' : '#ffffff',
                borderColor: statusFilter !== 'todos'
                  ? (isDark ? '#38bdf8' : '#0284c7')
                  : (isDark ? '#233142' : '#d8e2ef'),
                color: statusFilter !== 'todos'
                  ? (isDark ? '#38bdf8' : '#0284c7')
                  : (isDark ? '#f9fafd' : '#0f172a'),
                fontSize: '0.82rem',
                fontWeight: 600,
                minHeight: '38px',
                cursor: 'pointer'
              }}
              title="Filtrar por estado del ticket"
            >
              <div className="d-flex align-items-center text-truncate">
                <FontAwesomeIcon
                  icon={faFilter}
                  className="me-2"
                  style={{
                    color: statusFilter !== 'todos'
                      ? (isDark ? '#38bdf8' : '#0284c7')
                      : (isDark ? '#94a3b8' : '#64748b'),
                    fontSize: '0.75rem',
                    flexShrink: 0
                  }}
                />
                <span
                  style={{
                    display: 'inline-block',
                    width: '7px',
                    height: '7px',
                    borderRadius: '50%',
                    backgroundColor: currentStatusOption.dotColor,
                    marginRight: '6px',
                    flexShrink: 0
                  }}
                />
                <span className="text-truncate">{currentStatusOption.shortLabel}</span>
              </div>
              <div className="d-flex align-items-center gap-1 ms-1 flex-shrink-0">
                <span
                  className="badge rounded-pill px-2 py-0.5"
                  style={{
                    fontSize: '0.70rem',
                    fontWeight: 600,
                    backgroundColor: isDark ? '#1e293b' : '#e2e8f0',
                    color: isDark ? '#cbd5e1' : '#475569'
                  }}
                >
                  {currentStatusOption.count ?? 0}
                </span>
                <FontAwesomeIcon
                  icon={faChevronDown}
                  style={{ fontSize: '0.65rem', color: isDark ? '#94a3b8' : '#64748b' }}
                />
              </div>
            </Dropdown.Toggle>

          <Dropdown.Menu
            className="shadow-lg border p-1"
            style={{
              minWidth: '220px',
              backgroundColor: isDark ? '#121e2d' : '#ffffff',
              borderColor: isDark ? '#233142' : '#e2e8f0',
              color: isDark ? '#f9fafd' : '#0f172a',
              zIndex: 1050
            }}
          >
            <div
              className="text-uppercase fw-semibold px-2 py-1 mb-1 border-bottom"
              style={{
                fontSize: '0.66rem',
                color: isDark ? '#94a3b8' : '#64748b',
                borderColor: isDark ? '#233142' : '#f1f5f9'
              }}
            >
              Filtrar por Estado
            </div>
            {statusOptions.map(opt => {
              const isSelected = statusFilter === opt.id;
              return (
                <Dropdown.Item
                  key={opt.id}
                  as="button"
                  type="button"
                  onClick={() => onStatusChange(opt.id)}
                  className="d-flex align-items-center justify-content-between px-2 py-2 rounded-1 border-0"
                  style={{
                    backgroundColor: isSelected
                      ? (isDark ? 'rgba(56, 189, 248, 0.12)' : 'rgba(2, 132, 199, 0.08)')
                      : 'transparent',
                    color: isSelected
                      ? (isDark ? '#38bdf8' : '#0284c7')
                      : (isDark ? '#cbd5e1' : '#334155'),
                    fontSize: '0.82rem',
                    fontWeight: isSelected ? 600 : 500,
                    cursor: 'pointer'
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span
                      style={{
                        display: 'inline-block',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        backgroundColor: opt.dotColor
                      }}
                    />
                    <span>{opt.label}</span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span
                      className="badge rounded-pill px-2 py-0"
                      style={{
                        fontSize: '0.70rem',
                        fontWeight: 600,
                        backgroundColor: isSelected
                          ? '#0284c7'
                          : (isDark ? '#1e293b' : '#f1f5f9'),
                        color: isSelected ? '#ffffff' : (isDark ? '#94a3b8' : '#64748b')
                      }}
                    >
                      {opt.count ?? 0}
                    </span>
                    {isSelected && (
                      <FontAwesomeIcon
                        icon={faCheck}
                        style={{
                          fontSize: '0.72rem',
                          color: isDark ? '#38bdf8' : '#0284c7'
                        }}
                      />
                    )}
                  </div>
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Filtro de Fechas: 50% en móvil, auto en desktop alineado a la derecha */}
      <div className="col-6 col-lg-auto ms-lg-auto report-filter-date-wrapper">
        <TicketsDateFilter
          dateFilter={dateFilter}
          onChangeDateFilter={onDateChange}
        />
      </div>

      {/* Filtro de Asesor: 100% en móvil, auto en desktop */}
      <div className="col-12 col-lg-auto report-filter-agent-wrapper">
        <AgentFilterSelect
          selectedAgentId={selectedAgentId}
          onSelectAgent={onAgentChange}
          agents={agents}
          currentUserId={idUsuario}
          currentUserName={nombreCompleto}
          isLoadingAgents={isLoadingAgents}
        />
      </div>

      {/* Buscador: 100% en móvil, auto en desktop */}
      <div className="col-12 col-lg-auto">
        <div className="position-relative w-100" style={{ minWidth: '220px' }}>
          <input
            type="text"
            className="form-control form-control-sm ps-4 w-100"
            placeholder="Buscar en resultados..."
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
            style={{
              backgroundColor: isDark ? '#1e293b' : '#ffffff',
              borderColor: isDark ? '#233142' : '#e2e8f0',
              color: isDark ? '#f8fafc' : '#334155',
              height: '38px'
            }}
          />
          <FontAwesomeIcon
            icon={faSearch}
            className="position-absolute text-muted"
            style={{
              left: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '0.75rem'
            }}
          />
        </div>
      </div>
    </div>
  </div>
  );
};

export default ReportFilterBar;
